import React from "react";
import "./Portfoliogoldtoppage.css"; // Import the external CSS file
import { Link } from "react-router-dom";
import Navbar from "../../Navbar/Navbar";

const Portfoliogoldtop = () => {
  return (
     <div className="networth-stocks-dashboard">
    <h2 className="newwmutualmanagement" >
    Gold Portfoilo
  </h2>
  <div className="networth-tabs">
      <Link to="/portfolio">
        <button className="networth-tab ">Dashboard</button></Link>
        <Link to="/portfolio-management-stocks">
        <button className="networth-tab">Stocks</button></Link>
        <Link to="/portfolio-management-mutual-funds">
        <button className="networth-tab">Mutual Fund</button></Link>
        <Link to="/portfolio-management-gold">
        <button className="networth-tabact">Gold</button></Link>
      </div>


    {/* Summary Section */}
    <div className="networth-summary">
      <div>
        <p className="networthp">My Net Worth</p>
        <h2>₹0</h2>
      </div>
      <div>
        <p className="networthp">Today's Gain / Loss</p>
        <h2 className="networth-positive">0 ▼ 0%</h2>
      </div>
      <div>
        <p className="networthp">Amount Invested</p>
        <h2>₹0</h2>
      </div>
      <div>
        <p className="networthp">Unrealized Gain</p>
        <h2 className="networth-positive">0 ▼ 0%</h2>
      </div>
    </div>
    <div>
        
         <h3 className="gold-returns-title">Monthwise Returns Generated by Gold</h3>
    <div className="gold-returns-container">
   
  
    {/* Month and % Returns in one row */}
    <div className="gold-returns-row combined">
      <div>
        <span className="gold-returns-label">Month:</span><br/>
        <span className="gold-returns-value"> 08 November 2024</span>
      </div>
     <div>
      <span className="gold-returns-label">Gold</span><br/>
      <span className="gold-returns-label">Closing Price</span><br/>
      <span className="gold-returns-value highlighted">₹75,985.00</span>
      </div>
      <div><br/>
        <span className="gold-returns-label">% Returns:</span><br/>
        <span className="gold-returns-value highlighted"> 58.29%</span>
      </div>
    </div>
   
    </div>
    </div>
    <Navbar/>
  
    </div>
  
  );
};

export default Portfoliogoldtop;